let isFirstTimeLoaded = true;
let isFirsttimerequested = true;
let isRemovedSlideCalled = false;
let isMenuUpdated = false;
const initializeBodyObservation = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
     
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if(targetNode.classList.contains('js-drawer-open-cart') == false){
          //  console.log(mutation,"mutation");
          if (targetNode.classList.contains('neb-ab018-1')) {
            removeSlide();
          } else {
            restoreSlide();
          }

          if(targetNode.classList.contains("neb-ab016-1")){
            updateAB016Content();
          }
          if(targetNode.classList.contains("neb-ab011-1")){
           setMenuForAB011();
          }else{
            restorMenuForAB011();
          }
          if(targetNode.classList.contains("neb-ab015-1")){
            updateAB015Content();
          }
          if(targetNode.classList.contains("neb-ab017-1") || targetNode.classList.contains("neb-ab017-2") || targetNode.classList.contains("neb-ab017-3") || targetNode.classList.contains("neb-ab017-4"))
          {
            console.log('call neb 017');
           let is_body_exit = targetNode.classList.contains("neb-ab017-1") || targetNode.classList.contains("neb-ab017-3");
            if(is_body_exit){
              setTimeout(function(){
               let element = document.querySelector('.checkBoxContainer input');
              if(element){
              element.checked = true;
              updateAppProductOnCartDrawer();
                }
            }, 200);
            }
          }
          if(targetNode.classList.contains("neb-ab013-2") || targetNode.classList.contains("neb-ab013-3") || targetNode.classList.contains("neb-ab013-1")){
           let hedermenu = document.querySelector(".header_top_menu");
            hedermenu.style.display = "none";
          }else if(targetNode.classList.contains("neb-ab013-4")){
            let hedermenu = document.querySelector(".header_top_menu");
            hedermenu.style.display = "block";
           
            
            if(!targetNode.classList.contains("template-index")){
              let pagecontiner = document.querySelector("#PageContainer");
              pagecontiner.style.paddingTop = "123px";
            }
          }
          if(targetNode.classList.contains("neb-ab011-1")){
            document.querySelectorAll(".custom-container-menu").forEach((el) =>{
              if(el.classList.contains("custom-hide")){
                el.classList.remove("custom-hide")
              }
            });
          }else{
            document.querySelectorAll(".custom-container-menu").forEach((el) =>{
              if(!el.classList.contains("custom-hide")){
                el.classList.add("custom-hide")
              }
            });
          }
          updateAB014Content();
        }
        if(targetNode.classList.contains("js-drawer-open-cart")){
          if(isFirsttimerequested){
             //updateAppProductOnCartDrawerHtml();
          }
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
function updateAB014Content(){
  if($('body.neb-ab014-1').length > 0){
    if($(".trustpiolt-section").length > 0){
      const parentElement = $(".trustpiolt-section").parent(".shopify-section");
      const prevElement = parentElement.prev(".shopify-section");
      if(prevElement.find(".trustpilot-widget").length > 0){
        prevElement.css("display","none");
      }
    }
  }else{
    if($(".trustpiolt-section").length > 0){
      const parentElement = $(".trustpiolt-section").parent(".shopify-section");
      const prevElement = parentElement.prev(".shopify-section");
      if(prevElement.find(".trustpilot-widget").length > 0){
        prevElement.css("display","block");
      }
    }
  }
}
function updateAB015Content(){
  window.dispatchEvent(new Event("resize"));
}
let mainSliderImages;
let thumbSliderImages;
if(document.querySelectorAll('.product-single__media-slider').length > 0){
  mainSliderImages = document.querySelectorAll('.product-single__media-slider .product-single__media-slide')
}
if(document.querySelectorAll('.product-single__thumbnails').length > 0){
  thumbSliderImages = document.querySelectorAll('.product-single__thumbnails .product-single__thumbnail')
}
function restorMenuForAB011(){
  if(isMenuUpdated == true){
    document.querySelectorAll(".custom-container-menu").forEach((el) =>{
      if(!el.classList.contains("custom-hide")){
        el.classList.add("custom-hide")
      }
    });
  }
  
}
function setMenuForAB011(){
  isMenuUpdated = true;
   document.querySelectorAll(".custom-container-menu").forEach((el) =>{
    if(el.classList.contains("custom-hide")){
      el.classList.remove("custom-hide")
    }
  });
}
// Function to remove a specific slide
function removeSlide() {
  isRemovedSlideCalled = true;
  if(window.theme.settings.neb_ab018_option == 'test'){
    isFirstTimeLoaded = false;
  }
  if(document.querySelectorAll('.product-single__media-slider').length > 0){
    var flktyMain = themeVendor.Flickity.data(document.querySelector('.product-single__media-slider'));
    var flktyThumbs = themeVendor.Flickity.data(document.querySelector('.product-single__thumbnails'));
    
    const productVideoSlides = document.querySelectorAll(`.product-single__media-slide[data-type="video"]`);
    flktyMain.remove(productVideoSlides);
    flktyMain.reloadCells();
    if(productVideoSlides.length > 0){
      productVideoSlides.forEach((ele) => {
        const slide = document.querySelector(`.product-single__thumbnails .product-single__thumbnail[data-id="${ele.dataset.id}"]`);
          flktyThumbs.remove(slide);
      });
      flktyThumbs.reloadCells();
    }
  }
  
}

// Function to restore the removed slide
function restoreSlide() {
  if(isFirstTimeLoaded == false && isRemovedSlideCalled == true){
    if(document.querySelectorAll('.product-single__media-slider').length > 0){
      var flktyMain = themeVendor.Flickity.data(document.querySelector('.product-single__media-slider'));
      var flktyThumbs = themeVendor.Flickity.data(document.querySelector('.product-single__thumbnails'));
      
      if(mainSliderImages.length > 0){
        mainSliderImages.forEach((ele) => {
            if(ele.dataset.type == 'video'){
               flktyMain.insert(ele,1);
              thumbSliderImages.forEach((elem) => {
                if(elem.dataset.id == ele.dataset.id){
                  flktyThumbs.insert(elem,1);
                }
              });
            }
        });
      }
     
      flktyMain.reloadCells();
      flktyThumbs.reloadCells();
      
    }
  }
 
}

document.addEventListener("DOMContentLoaded", (event) => {
  initializeBodyObservation();
  if(window.theme.settings.neb_ab018_option == 'implement'){
    removeSlide();
  }

  if(window.theme.settings.neb_ab014_option == 'implement'){
    updateAB014Content();
  }
 
  if(document.querySelectorAll(".mobile-nav__trigger-2").length > 0){
    document.querySelectorAll(".mobile-nav__trigger-2").forEach( (el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          //$("#nav-drawer").scrollTop(0);
          const dataId = evt.currentTarget.dataset.slug
          const el = document.querySelector(`.custom-container-menu[data-slug="${dataId}"]`);
          el.classList.remove('hidedefault');
           document.querySelectorAll(".custom-container-menu").forEach( (el2) => {
              el2.classList.remove("active");
            });
          setTimeout( () => {
            
            const el2 = document.querySelector(`.custom-container-menu[data-slug="${dataId}"]`);
            el2.classList.add('active');

             document.querySelectorAll(".hideifthird-level-menu-open").forEach( (el2) => {
               setTimeout(()=> {  el2.style.opacity="0";},200);
            });
            $('.custom-container-menu').siblings('.main-manuin-mobile').addClass('right-left');
          },100);
          //jQuery("div#nav-drawer").removeAttr('data-scroll-lock-scrollable');
         
          return false;
        });
      
    });
    document.querySelectorAll(".custom-container-menu .back-button").forEach( (el) => {
        el.addEventListener("click", (evt) => {
          evt.preventDefault();
          document.querySelectorAll(".custom-container-menu").forEach( (el2) => {
            el2.classList.remove("active");
          });
          document.querySelectorAll(".hideifthird-level-menu-open").forEach( (el2) => {
            el2.style.opacity="1";
          });
           setTimeout( () => {
             document.querySelectorAll(".custom-container-menu").forEach( (el2) => {
              el2.classList.add("hidedefault");
            });
           },400);
        });
    });
   
  }
  if(document.querySelectorAll(".logo-content-slider .slider").length > 0){
     var galleryThumbs = new Swiper('.slider-thumbnail', {
        loop: true,
        slidesPerView: 1,
        // slideToClickedSlide: false,
      });
      var galleryTop = new Swiper('.logo-content-slider .slider', {
        loop: true,
        centeredSlides: true,
        spaceBetween: 30,
        slideToClickedSlide: true,
        slidesPerView: 7,
        breakpoints: {
          1400: {
            slidesPerView: 7
          },
          1100: {
            slidesPerView: 6
          },
          991: {
            slidesPerView: 5
          },
          768: {
            slidesPerView: 3
          },
          380: {
            slidesPerView: 3
          },
          320: {
            slidesPerView: 2
          }
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: true,
        },
      });

    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop
  }
   
});
$(document).ready(function() {
  $('.custom-footer-menu-wrapper').addClass('sticky');
  $('button.mobile-nav__trigger-2').click(function(){
    $('ul.mobile-nav.mobile-nav--weight-bold.hideifthird-level-menu-open').siblings('.custom-footer-menu-wrapper').addClass('sticky');
    $('.mobile-dropdown.is-expanded').parents('ul.mobile-nav.mobile-nav--weight-bold.hideifthird-level-menu-open').siblings('.custom-footer-menu-wrapper').removeClass('sticky');
    setTimeout(() => {
      $('.custom-container-menu').siblings('.main-manuin-mobile').removeClass('hide-menu-bar');
    }, 400);
     
  });
  $('.custom-container-menu').siblings('.main-manuin-mobile').addClass('hide-menu-bar');
  $(".drawer-custom-heading-image label.back-button").click(function(){
    $(this).parents(".custom-container-menu.drawer__scrollable").addClass("left-right-animation");
     $('.custom-container-menu').siblings('.main-manuin-mobile').addClass('hide-menu-bar');
      $('.custom-container-menu').siblings('.main-manuin-mobile').removeClass('right-left');
    $('.drawer-custom-heading-image-wrapper').addClass('frist-menu-slow');
    setTimeout(() => {
      $('.drawer-custom-heading-image-wrapper').removeClass('frist-menu-slow');
      $(".custom-container-menu.drawer__scrollable").removeClass("left-right-animation");
       $('.custom-container-menu').siblings('.main-manuin-mobile').removeClass('right-left');
    }, 400);
  });
   //jQuery(".main-manuin-mobile.hide-menu-bar").css("height", "80vh");
  
});


// product page ugc video slider
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/11.0.5/swiper-bundle.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}
function updateAB016Content(){
  window.dispatchEvent(new Event("resize"));
}
document.addEventListener("DOMContentLoaded", (event) => {
    $('#read-more').click(function (){
      $('#product-description').show();
      $('#truncated-product-description').hide();
    });
   $('#read-less').click(function (){
      $('#product-description').hide();
      $('#truncated-product-description').show();
    });
    if(document.querySelectorAll('.ajj_quanity_reviews span.reviews').length > 0){
     const reviewInterval = setInterval(()=>{
       if(document.querySelectorAll(".es-header-total-reviews-value").length > 0){
           document.querySelector('.ajj_quanity_reviews span.reviews').textContent = document.querySelector(".es-header-total-reviews-value").textContent;
         clearInterval(reviewInterval);
       }
    
    },1000);
  }
  
  if (typeof Swiper == "undefined") {
    addScript();
  }
  
  waitForSwiper(function () {
    if(document.querySelectorAll(".eg-video-section .swiper-container").length > 0){
      var egswiperTiktok = new Swiper(".eg-video-section .swiper-container", {
      // Optional parameters
      // direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 4,
      roundLengths: true,
      loop: false,
      arrow: true,
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 3.3,
        },
        800: {
          slidesPerView: 2.6,
          // arrow: false,
        },
        500: {
          slidesPerView: 1.2,
        },
        320: {
          slidesPerView: 1.2,
        },
      },
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    }
    
  });
});
/*async function updateAppProductOnCartDrawer() {
  const cartresponse = await fetch('/cart.js');
  const cartdata = await cartresponse.json();

  const pdid = document.querySelector('.checkBoxContainer input')?.dataset.pid;
  const defSelected = document.querySelector('.checkBoxContainer input')?.checked;

  const autoAtcEl = document.querySelector('.cart-item--auto-atc');
  const offreSpecialeEl = document.querySelector('.cart-item--offre-speciale');

  // 💣 Si auto_atc n'existe plus, mais app_offre_speciale est présent => remove
  if (!autoAtcEl && offreSpecialeEl) {
    const offreSpecialeId = offreSpecialeEl.getAttribute('data-id');
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: offreSpecialeId, quantity: 0 })
    });
    console.log("✔ app_offre_speciale retiré car auto_atc supprimé.");
    cart.getCart();
  }

  // 🔁 Gestion de la checkbox upsell si présente
  if (pdid) {
    const isAdded = cartdata.items.find(item => item.id == Number(pdid));

    if (isAdded && cartdata.item_count === 1) {
      document.querySelector(`.cart__item__remove[data-id="${isAdded.key}"]`)?.dispatchEvent(new Event('click'));
    } else if (!isAdded && defSelected && pdid !== "") {
      let formData = { items: [{ id: pdid, quantity: 1 }] };
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      cart.getCart();
    } else if (isAdded && !defSelected) {
      document.querySelector(`.cart__item__remove[data-id="${isAdded.key}"]`)?.dispatchEvent(new Event('click'));
    }
  }
}*/

document.addEventListener("click", async (e) => {
  const btn = e.target.closest("[data-item-remove]");
  if (!btn) return;

  e.preventDefault();

  const key = btn.dataset.id;

  // 1. Charger le panier JSON (toujours utiliser la source fiable)
  const res = await fetch('/cart.js');
  const cartData = await res.json();

  // 2. Trouver l’item cliqué dans le vrai panier
  const clickedItem = cartData.items.find(item => item.key === key);
  if (!clickedItem) return;

  const parentVariant = clickedItem.properties?.parent_variant || null;
  const isApp = !!parentVariant;
  const isParent = !isApp;

  let toDelete = [ key ];

  // 3. Si c’est un parent → supprimer l’app liée
  if (isParent) {
    const linkedApps = cartData.items.filter(item =>
      item.properties?.parent_variant == clickedItem.variant_id
    );

    linkedApps.forEach(app => toDelete.push(app.key));
  }

  // 4. Si c’est une app → ne supprimer QUE cette app (logique propre)
  // (donc rien à ajouter dans toDelete)

  // 5. Supprimer proprement
  for (const k of toDelete) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: k, quantity: 0 })
    });
  }

  // 6. Refresh du drawer
  if (typeof cart !== "undefined" && typeof cart.getCart === "function") {
    await cart.getCart();
  }
});









document.addEventListener("DOMContentLoaded", (event) => {
  function updateLastVisibleChild() {
    const items = document.querySelectorAll('.accordion .accordion-inner-item');
    let lastVisibleItem = null;

    items.forEach(item => {
        item.classList.remove('last-visible');
        if (item.style.display !== 'none') {
            lastVisibleItem = item;
        }
    });

    if (lastVisibleItem) {
        lastVisibleItem.classList.add('last-visible');
    }
}

// Call the function to initialize the last visible item
updateLastVisibleChild();

// Example: Update the last visible item when an item is hidden or shown
document.querySelectorAll('.accordion .accordion-inner-item').forEach(item => {
    item.addEventListener('change', updateLastVisibleChild);
});
    $(document).on("change",'.checkBoxContainer input',function(){
      updateAppProductOnCartDrawer();
    });
    document.addEventListener("drawerupdated", function(evt) {
      console.log("cart update with custom event");
      updateAppProductOnCartDrawer();
    });   
  
});